import React from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { EntityState, EntityTypeEnum, OrganisationMetaDetail, WorkflowActions } from 'api'
import { DataGrid, GridId } from 'view/components/datagrid'
import { TradeSplitColumnDefs, tradeSplitGridOptions } from './TradeSplitGridModel'
import { organisationMetaDetailsSelector } from 'selectors/organisationSelectors'

interface TradeSplitGridProps {
  organisationMetaList: OrganisationMetaDetail[]
  updateTradeSplit: typeof WorkflowActions.createEntitiesCreateAndSubmitReferenceData
}

const mapStateToProps = createStructuredSelector({
  organisationMetaList: organisationMetaDetailsSelector
})

const mapDispatchToProps = {
  updateTradeSplit: WorkflowActions.createEntitiesCreateAndSubmitReferenceData
}

export const TradeSplitGridComponent: React.FunctionComponent<TradeSplitGridProps> = props => {
  const { organisationMetaList, updateTradeSplit } = props

  const onUpdateTradeSplit = (_rowId: string, rowItem: OrganisationMetaDetail, _updatedField: string, enabled: any) => {
    updateTradeSplit(
      [
        {
          data: { ...rowItem.organisationMeta, splitTrades: enabled },
          entityState: EntityState.EXISTING,
          entityTypeEnum: EntityTypeEnum.ORGANISATION_META,
          id: rowItem.organisationMeta.id,
          validationIssues: []
        }
      ],
      []
    )
  }

  return (
    <DataGrid
      gridId={GridId.TradeSplitGrid}
      gridOptions={tradeSplitGridOptions}
      columnDefs={TradeSplitColumnDefs}
      rowData={organisationMetaList}
      onCellValueUpdated={onUpdateTradeSplit}
    />
  )
}

export const TradeSplitGrid = connect(mapStateToProps, mapDispatchToProps)(TradeSplitGridComponent)
